export default __webpack_public_path__ + "static/media/premium-icon.13fcf93a.svg";